module.exports = __webpack_public_path__ + "img/tabbed-search-filter-infiniti.ef7405b0.png";